module.exports = __webpack_public_path__ + "img/pic_contact.4998cd7c.png";